// UGC ad prices in credits (must match UGC_QUALITY_CREDITS in backend/server.py)
export const UGC_CREDITS = { standard: 2, standard_30s: 3, premium: 3, premium_30s: 4.5 };

export const ugcAdCost = (quality, duration) =>
  quality === "standard" ? (duration >= 30 ? UGC_CREDITS.standard_30s : UGC_CREDITS.standard) : duration >= 30 ? UGC_CREDITS.premium_30s : UGC_CREDITS.premium;
